import React from 'react';

const TableTotal = ({ className, style, total, singular, plural }) => (
  <span className={className} style={style}>
    {total} {total === 1 ? singular : plural}{' '}
  </span>
);

export default TableTotal;
